import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';

function* getFeesAndLimits() {
  try {
    const { data, status } = yield call(api.feesAndLimits.getFeesAndLimits);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_FEES_AND_LIMITS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_FEES_AND_LIMITS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* editFeesAndLimits({ payload }) {
  try {
    const { status } = yield call(api.feesAndLimits.editFeesAndLimits, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_FEES_AND_LIMITS_SUCCESS });
    yield put({ type: types.GET_FEES_AND_LIMITS_START });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.PUT_FEES_AND_LIMITS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* feesAndLimits() {
  yield all([
    takeLatest(types.GET_FEES_AND_LIMITS_START, getFeesAndLimits),
    takeLatest(types.PUT_FEES_AND_LIMITS_START, editFeesAndLimits),
  ]);
}
